import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { toggleBodyFixed, getOffsetRect } from '../helpers';
import GalleryComponent from './GalleryComponent';
import * as GalleryActions from './GalleryActions';
import { toggleFullscreen } from '../app/AppActions';
import ReactGA from 'react-ga';

import './Style';

class GalleryMobileContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            imagesToShow: [],
            galleryPortalVisible: false,
            activeImage: '',
            windowInnerWidth: window.innerWidth
        }

        this.showMoreBtnClick = this.showMoreBtnClick.bind(this);
        this.galleryFullscreenOpen = this.galleryFullscreenOpen.bind(this);
        this.onWindowResize = this.onWindowResize.bind(this);
    }

    componentDidMount () {
        const { images, galleryActions } = this.props;
        window.addEventListener('resize', this.onWindowResize, false);

        if (images.length > 10) {
            this.setState({ imagesToShow: images.slice(0, 10) });
        } else {
            this.setState({ imagesToShow: images });
            window.innerWidth >= 768 && galleryActions.showAllPhotos();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onWindowResize, false);
        toggleBodyFixed(false);
    }

    onWindowResize() {
        this.setState({
            windowInnerWidth: window.innerWidth
        });

        if (window.innerWidth <= 768 && this.state.galleryPortalVisible) {
            this.setState({
                galleryPortalVisible: false
            });

            toggleBodyFixed();
        }
    }

    galleryFullscreenOpen(id, imageName, element) {
        const { galleryActions } = this.props;
        galleryActions.setActiveImage(imageName);
        this.props.goToFullscreenGallery(id, getOffsetRect(element).top);
        // ReactGA.event({
        //     category: 'gallery',
        //     action: 'open full screen'
        // });
    }

    // getImageHeight(ref) {
    //     console.log('ref', ref.clientHeight)
    //     this.setState({
    //         imageHeight: ref.clientHeight
    //     })
    // }

    showMoreBtnClick() {
        // ReactGA.event({
        //     category: 'gallery',
        //     action: 'click view all'
        // });
        this.setState({ imagesToShow: this.props.images });
        this.props.galleryActions.showAllPhotos();
    }

    render () {
        const { images, imagesPath, imageSizeParams, allPhotos } = this.props;

        const getComponentsArray = () => {
            const galleryBlock = [];

            for (let i = 0; i < images.length; i++) {
                galleryBlock.push(
                    <GalleryComponent
                        images={images.slice(i, i + 1)}
                        imagesPath={imagesPath}
                        imageSizeParams={imageSizeParams}
                        key={i}
                        imageKey={i}
                        galleryItemClick={this.galleryFullscreenOpen}
                    />
                );
            }

            return galleryBlock;
        }

        const showMoreBlock = allPhotos
            ? null
            : (
                <div className="more-btn-wrapper">
                    <button className='btn' onClick={this.showMoreBtnClick}>
                        View all <b>{images.length}</b> photos
                    </button>
                </div>
            );

        return (
            <div className="gallery-container">
                <div style={{maxHeight: allPhotos ? 'none' :(this.state.windowInnerWidth / 1.33) *3 + 'px'}} className={allPhotos ? 'gallery-wrapper all-photos' : 'gallery-wrapper'}>
                    {getComponentsArray()}
                    {showMoreBlock}
                </div>
            </div>
        )
    }
}

GalleryMobileContainer.propTypes = {
    imagesPath: PropTypes.string.isRequired,
    images: PropTypes.array.isRequired,
    imageSizeParams: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    return {
        imagesPath: state.gallery.imagesPath,
        images: state.gallery.images,
        imageSizeParams: state.gallery.imageSizeParams,
        allPhotos: state.gallery.allPhotos
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toggleFullscreen: bindActionCreators(toggleFullscreen, dispatch),
        galleryActions: bindActionCreators(GalleryActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GalleryMobileContainer)